import React, { Component } from 'react';
import EventIntro from '../Event/EventIntro';
import EventIntroCondensed from '../Event/EventIntroCondensed';
// import config from 'config/api';
// import LiveHelp from '../Lives/LiveHelp';
// import AvailableEvents from 'components/Event/AvailableEvents';
// import EventSelector from "components/Event/EventSelector";
import HomeHelp from 'components/Home/HomeHelp';
import BlockRatio from 'components/BlockRatio';
import BlockButton from 'components/UI/BlockButton';
import Immutable from 'immutable';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import clsx from 'clsx';
import { withRouter } from 'react-router-dom';
import { formatDate } from 'helpers/stringUtils';
import RemainingTime from 'components/UI/RemainingTime';
import getRemainingTime from 'helpers/getRemainingTime';
import WarningIcon from '@material-ui/icons/Warning';
import config from 'config/api';
import gotoLiveRoom from 'helpers/gotoLiveRoom';
import getThemeImage from 'helpers/getThemeImage';
import i18n from 'helpers/i18n';
import Paragrapher from 'components/UI/Paragrapher';
const styles = (theme) => {
  return {
    root: {
      '& .MuiButton-root.MuiButton-sizeLarge': {
        // width: '90%',
        // marginLeft: '10%',
        boxShadow: theme.shadows[4],
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        backgroundColor: '#fff',
        opacity: 0.9,
        fontSize: '1.3rem',
        '&:hover': {
          color: '#fff',
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    whiteBg: {
      position: 'relative',
      marginBottom: (process.env.REACT_APP_SITE === 'neuro' || process.env.REACT_APP_SITE === 'dermato' || process.env.REACT_APP_SITE === 'dermato_rs' ? theme.spacing(3) : 0),
      // marginBottom: theme.spacing(4),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: 0,
        content: "' '",
        width: '100%',
        height: '100%',
        backgroundColor: (process.env.REACT_APP_SITE === 'neuro' || process.env.REACT_APP_SITE === 'dermato' || process.env.REACT_APP_SITE === 'dermato_rs' ? '#fff' : 'transparent'),
        opacity: 0.9,
        borderRadius: 5
      },
    },
    relative: {
      position: 'relative',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },

    offsetLeft: {
      width: '90%',
      marginLeft: '10%',
    },
    inline: {
      display: 'inline-block',
    },
    emphasis: {
      color: theme.palette.secondary.main,
    },
    titleWrapper: {
      // borderBottom: '2px ' + theme.palette.primary.main + ' solid',
      marginBottom: 20,
      minHeight: 80,
    },
    titleImage: {
      width: 60,
      height: 60,
      display: 'inline-block',
      verticalAlign: 'bottom',
      marginRight: 20,
    },
    titleLabel: {
      // color: theme.palette.text.titleColor,
      color: (process.env.REACT_APP_SITE === 'neuro' ? theme.palette.primary.main : theme.palette.text.titleColor),
      // textShadow: '1px 1px 2px '+theme.palette.text.shadowColor,
      textShadow: (process.env.REACT_APP_SITE === 'hemato' ? '1px 1px 2px '+theme.palette.text.shadowColor : 'none'),
      display: 'block',
      // paddingRight: '30%',
      // width: 'calc(100% - 80px)',
      width: '100%',
      // display: 'inline-block',
      // verticalAlign: 'top',
      textAlign: 'left',
      // fontSize: '1.2rem',
      // fontSize: '5rem',
      // lineHeight: '5.8rem',
      // fontSize: '4rem',
      // fontSize: '3rem',
      // lineHeight: '3.9rem',
      // fontSize: '2.6rem',
      // lineHeight: '3rem',
      fontSize: '2.3rem',
      lineHeight: '2.7rem',

      // textTransform: 'uppercase',
      // borderBottom: '2px '+theme.palette.text.titleColor+' solid',
      borderBottom: '2px '+(process.env.REACT_APP_SITE === 'neuro' ? theme.palette.primary.main : theme.palette.text.titleColor)+' solid',
      paddingBottom: theme.spacing(2),

      '& em': {
        fontStyle: 'normal',
        backgroundColor: '#fff',
        color: theme.palette.primary.main,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '2.1rem',
        lineHeight: '2.5rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.8rem',
        lineHeight: '2.2rem',
        textAlign: 'center',
        paddingRight: 0,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.2rem',
        lineHeight: '1.9rem',
      },
    },
    cardDescription: {
      textAlign: 'left',
      // color: theme.palette.text.titleColor,
      color: (process.env.REACT_APP_SITE === 'neuro' ? theme.palette.primary.main : theme.palette.text.titleColor),
      // textShadow: '1px 1px 2px '+theme.palette.text.shadowColor,
      textShadow: (process.env.REACT_APP_SITE === 'hemato' ? '1px 1px 2px '+theme.palette.text.shadowColor : 'none'),
      // minHeight: 230,
      fontSize: '1.4rem',
      fontWeight: 'bold',
      width: '100%',
      [theme.breakpoints.up('lg')]: {
        // minHeight: 260,
        // minHeight: 150,
      },
      [theme.breakpoints.down('md')]: {
        // minHeight: 140,
        fontSize: '1.2rem',
      },
      [theme.breakpoints.down('sm')]: {
        // minHeight: 140,
        fontSize: '1.1rem',
      },
      [theme.breakpoints.down('xs')]: {
        minHeight: 'auto',
        fontSize: '1.0rem',
      },
    },
    dynamicColor: {
      color: (process.env.REACT_APP_SITE === 'neuro' ? theme.palette.primary.main : theme.palette.text.titleColor),
      // borderColor: 'inherit',
    },
    mainColor: {
      color: theme.palette.primary.main,
      borderColor: 'inherit',
    },
    subTitle: {
      // textAlign: 'left',
      // color: theme.palette.text.titleColor,
      color: (process.env.REACT_APP_SITE === 'neuro' ? theme.palette.primary.main : theme.palette.text.titleColor),
      // textShadow: '1px 1px 2px '+theme.palette.text.shadowColor,
      textShadow: (process.env.REACT_APP_SITE === 'hemato' ? '1px 1px 2px '+theme.palette.text.shadowColor : 'none'),
      fontWeight: 700,
      fontSize: '2rem',
      width: '100%',
      // borderBottom: '2px '+theme.palette.text.titleColor+' solid',
      borderBottom: '2px '+(process.env.REACT_APP_SITE === 'neuro' ? theme.palette.primary.main : theme.palette.text.titleColor)+' solid',
      paddingBottom: theme.spacing(3),
      textAlign: 'left',
    },
    legend: {
      display: 'inline-block',
    },
    negativeTop: {
      marginTop: '-65px',
      height: '60px',
      [theme.breakpoints.down('sm')]: {
        marginTop: '0',
        marginTop: '-85px',
        height: '80px',
      },
      [theme.breakpoints.down('xs')]: {
        marginTop: '0',
        height: 'auto',
      },
    },
  };
};
class ThemeCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLiveButton: false,
    };
    this._runRemainingTimer = this._runRemainingTimer.bind(this);
    this._gotoLiveRoom = this._gotoLiveRoom.bind(this);
  }
  componentDidMount() {
    this._startTimer();
  }
  componentDidUpdate(oldProps) {
    if (
      (oldProps.$$subscriptions === undefined && this.props.$$subscriptions !== undefined) ||
      oldProps.$$subscriptions !== this.props.$$subscriptions
    )
      this._startTimer();
  }
  componentWillUnmount() {
    this._stopTimer();
  }
  // componentDidUpdate(oldProps) {
  //    console.log(oldProps.$$data.toJS(), oldProps.userRole, this.props.userRole)
  //   if ((oldProps.userRole === undefined && this.props.userRole !== undefined) || this.props.userRole !== undefined && oldProps.$$data !== this.props.$$data) {
  //      console.log('GOGOGO')
  //     this._startTimer();
  //   }
  // }
  _gotoLiveRoom = (e) => {
    const { $$user } = this.props;
    e.preventDefault();
    const $liveEvent = this._getSubscribedEvent();
    gotoLiveRoom($liveEvent, (res) => {
      if (res === true) this._goto('/live/' + $liveEvent.get('id'));
    });
  };
  _stopTimer() {
    // console.log('timer stop')
    if (this._remainingTimer) {
      clearInterval(this._remainingTimer);
    }
  }
  _startTimer() {
    // console.log('timer start')
    if (this._remainingTimer) return;
    const $$subscribedEvent = this._getSubscribedEvent();
    // console.log('$$subscribedEvent', $$subscribedEvent)
    // console.log('trying to start')
    if ($$subscribedEvent === undefined) return this._stopTimer();
    // console.log('started')
    // console.log('starting timer')
    // this._cardTimer = $$card.get('eventDate');
    this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
    this._runRemainingTimer();
  }
  _runRemainingTimer() {
    // console.log('run1')
    const $$subscribedEvent = this._getSubscribedEvent();
    if ($$subscribedEvent === undefined) {
      return this._stopTimer();
    }
    // console.log('run3')
    // console.log($e)
    // console.log($e.get('eventState'))
    // console.log('ddsqdqs', $$subscribedEvent.toJS())
    // const timeRemaining = $$subscribedEvent !== undefined && $$subscribedEvent.get('eventState') != 'live'
    const timeRemaining =
      $$subscribedEvent !== undefined && $$subscribedEvent.get('eventState') !== 'live'
        ? getRemainingTime($$subscribedEvent.get('eventDate'))
        : {
            days: 0,
            hours: 0,
            minutes: 0,
          };
    // console.log(timeRemaining)
    if (timeRemaining.days <= 0 && timeRemaining.hours <= 0 && timeRemaining.minutes <= 15) {
      this.setState(
        {
          showLiveButton: true,
        },
        () => {
          // console.log('STOPPPING')
          this._stopTimer();
        },
      );
    } else {
      // console.log('RUN')
      this.setState({
        timeRemaining,
      });
    }
  }
  // _getMyLiveEvent() {
  //   const {$$data, $$subscriptions} = this.props;
  //   if ($$data !== undefined) {
  //     // console.log($$subscriptions)
  //     // console.log($$data.get('myfutureevents'))
  //   }
  //   // const $$subscriptions = this._getMySubscriptions();
  //   // return $$subscriptions !== undefined && $$subscriptions.size > 0 && $$subscriptions.get(0) !== undefined
  //   // ? $$data.get('myfutureevents').get(0)
  //   // : undefined;
  //   return undefined;
  // }
  // _getMyPastEvent() {
  //   const {$$data} = this.props;
  //   if ($$data !== undefined) {
  //     // console.log($$data.toJS())
  //     // console.log($$subscriptions)
  //     // console.log($$data.get('myfutureevents'))
  //     // console.log($$data.get('mypastevents').filter($e => $e.get('hasAttended') !== undefined && $e.get('hasAttended') !== '' && $e.get('hasAttended') !== null).toJS())
  //   }
  //   return $$data !== undefined && $$data.get('mypastevents') !== undefined && $$data.get('mypastevents').size > 0
  //   ? $$data.get('mypastevents').filter($e => $e.get('hasAttended') !== undefined && $e.get('hasAttended') !== '' && $e.get('hasAttended') !== null).get(0)
  //   : undefined;
  // }
  _goto(url) {
    const { history } = this.props;
    history.push(url);
  }
  _getSubscribedEvent() {
    const { $$themeData, $$subscriptions } = this.props;
    // console.log($$subscriptions, $$themeData)
    let subscribedEvent = [];
    $$themeData.map(($$event, i) => {
      if ($$subscriptions.contains($$event.get('id'))) {
        // console.log('matches ',i)
        subscribedEvent.push($$event);
      }
    });
    const $$subscribedEvent = Immutable.fromJS(subscribedEvent);
    // console.log($$subscribedEvent.toJS(), $$subscriptions.toJS());
    // console.log($$subscribedEvent.sortBy($e => $e.get('eventDate')).get(0).toJS());
    return $$subscribedEvent.sortBy(($e) => $e.get('eventDate')).get(0);
  }
  render() {
    const {
      $$themeData,
      tIdx,
      $$subscriptions,
      userRole,
      $$user,
      onSubscriptionComplete,
      classes,
      gridSize,
    } = this.props;
    // console.log({$liveEvent, $pastEvent})
    // if ($e !== undefined) console.log($e.toJS())
    const { showLiveButton } = this.state;
    const themeId = $$themeData.get(0).get('themeId');
    const themeThumb = getThemeImage($$themeData.get(0), 'themThumb');
    const themeColor = $$themeData.get(0).get('themeColor');
    // const $liveEvent = this._getMyLiveEvent();
    const $$subscribedEvent = this._getSubscribedEvent();
    // const timeRemaining = $$subscribedEvent !== undefined
    // ? getRemainingTime($$subscribedEvent.get('eventDate'))
    // : {};
    // const gridSizes = [
    //   {
    //     xs: 12,
    //     sm: 12,
    //     md: 12,
    //     lg: 6,
    //   },
    //   {
    //     xs: 12,
    //     sm: 6,
    //     md: 6,
    //     lg: 4,
    //   },
    //   {
    //     xs: 12,
    //     sm: 6,
    //     md: 4,
    //     lg: 4,
    //   },
    // ];
    const gridSizes = [
      {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
      },
      {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
      },
      {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
      },
    ];
    const gs = gridSize <= 2 ? gridSize : 2;
    return (
      <Grid
        key={'thm_' + tIdx}
        item={true}
        xs={gridSizes[gs].xs}
        sm={gridSizes[gs].sm}
        md={gridSizes[gs].md}
        lg={gridSizes[gs].lg}
        className={clsx(classes.root, classes.whiteBg)}
        container
      >
        <Grid item xs={12} container className={classes.relative}>
          <Grid item xs={12} md={8} container>
            <Typography variant={'h2'} gutterBottom={true} className={clsx(classes.titleWrapper)}>
              <span className={classes.titleLabel}>
                <Paragrapher prettyfy={true} text={$$themeData.get(0).get('themeName')} />
              </span>
            </Typography>
            <If
              condition={
                $$themeData.get(0).get('themeSubTitle') !== undefined &&
                $$themeData.get(0).get('themeSubTitle') !== '' &&
                $$themeData.get(0).get('themeSubTitle') !== null
              }
            >
              <Typography
                variant={'body1'}
                gutterBottom={true}
                className={clsx(classes.subTitle, {})}
                component={'div'}
              >
                <Paragrapher element={'div'} text={$$themeData.get(0).get('themeSubTitle')} prettyfy={true} />
              </Typography>
            </If>
            <Typography
              variant={'body1'}
              gutterBottom={true}
              className={clsx(classes.cardDescription, {})}
              component={'div'}
            >
              <Paragrapher
                element={'div'}
                text={$$themeData.get(0).get('themeDescription')}
                prettyfy={true}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} container alignContent="center">
            <If condition={$$subscribedEvent !== undefined}>

              <If condition={showLiveButton !== true}>
                <Box className={classes.offsetLeft} align="center">
                  <Typography variant="body1" gutterBottom={true} className={clsx(classes.dynamicColor)}>
                    {i18n.get('headerTitle')}
                  </Typography>
                  <Typography
                    variant="h6"
                    className={clsx(classes.legend, classes.dynamicColor)}
                    gutterBottom={true}
                  >
                    {formatDate($$subscribedEvent.get('eventDate'), 'dddd dd mmmm yyyy')} à{' '}
                    {formatDate($$subscribedEvent.get('eventDate'), "HH'h'MM")}
                  </Typography>
                </Box>
                <Box mt={2} width="100%" align="center" className={classes.offsetLeft}>
                  <Button
                    size={'large'}
                    onClick={(e) => {
                      e.preventDefault();
                      this._goto('/subscribe/' + themeId);
                    }}
                  >
                    Modifier la session
                  </Button>
                </Box>
              </If>
              <If condition={showLiveButton === true}>
                <Box width="100%" align="center">
                <Typography variant="h6" gutterBottom={true} >
                  La conférence a déjà débuté !
                </Typography>
</Box>
                <Box mt={2} width="100%" align="center">
                  <Button size={'large'} onClick={this._gotoLiveRoom}>
                    Accéder au live
                  </Button>
                </Box>
              </If>
            </If>

            <If condition={$$subscribedEvent === undefined}>
              <Box mt={2} width="100%" align="center">
                <Button
                  size={'large'}
                  onClick={(e) => {
                    e.preventDefault();
                    this._goto('/subscribe/' + $$themeData.get(0).get('themeId'));
                  }}
                >
                  {i18n.get('homeRegisterBtn')}
                </Button>
              </Box>
            </If>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
export default withRouter(withStyles(styles)(ThemeCard));



// WEBPACK FOOTER //
// ./src/components/Theme/ThemeCard.jsx